(function() {
  'use strict';

  angular.module('mean.accounts-receivable').directive('expand', function () {
    function link(scope, element, attrs) {
        scope.$on('onExpandAll', function (event, args) {
            scope.expanded = args.expanded;
        });
    }
    return {
        link: link
    };
  });
})();



// WEBPACK FOOTER //
// ./packages/custom/accounts-receivable/public/directives/expand.js